import { Trans } from '@lingui/react';
import styled, { css } from 'styled-components';
import { theme } from '~globalStyles';
import { Mode } from '~services/business/pricing';

type PricingSwitcherProps = {
    mode: Mode;
    onSelectSide: () => void;
};

export const PricingSwitcher = ({
    onSelectSide,
    mode,
}: PricingSwitcherProps) => {
    return (
        <SwitchWrapper>
            <PricingSwitch>
                <SelectSide
                    type="button"
                    onClick={onSelectSide}
                    active={mode === Mode.MONTHLY}
                >
                    <Trans id="global.pricing.monthly" />
                </SelectSide>
                <SelectSide
                    type="button"
                    onClick={onSelectSide}
                    active={mode === Mode.YEARLY}
                >
                    <Trans id="global.pricing.yearly" />
                    <YearlyDiscount active={mode === Mode.YEARLY}>
                        %
                    </YearlyDiscount>
                </SelectSide>
            </PricingSwitch>
        </SwitchWrapper>
    );
};

const SwitchWrapper = styled.div`
    margin: 2rem;
    display: flex;
    justify-content: center;
`;

const PricingSwitch = styled.div`
    background: ${({ theme }) => theme.lightPurple};
    border-radius: 22px;
    box-shadow: ${({ theme }) => theme.switchBoxShadow};
`;

const SelectSide = styled.button`
    height: 100%;
    background: none;
    box-shadow: none;
    border-radius: 22px;
    border: none;
    padding: 8px 20px;
    font-family: ${({ theme }) => theme.primaryFont};
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    letter-spacing: 0.833333px;
    color: ${({ theme }) => theme.darkPurple3};
    text-transform: uppercase;
    ${({ active }) =>
        active &&
        css`
            background: ${({ theme }) => theme.darkPurple};
            box-shadow: 0px 5px 7px rgba(82, 67, 194, 0.23);
            color: ${theme.lightPurple};
            transition: background 0.5s, color 0.5s;
        `}
`;

const YearlyDiscount = styled.span`
    background: ${({ theme }) => theme.darkPurple};
    font-weight: 600;
    font-size: 14px;
    line-height: 30px;
    color: ${theme.lightPurple};
    border-radius: 30px;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-left: 10px;
    margin-right: -10px;
    ${({ active }) =>
        active &&
        css`
            background: ${theme.lightPurple};
            color: ${({ theme }) => theme.darkPurple2};
            transition: background 0.5s, color 0.5s;
        `}
`;
